import { isIphoneX } from 'react-native-iphone-x-helper';
import { Platform } from 'react-native';

export const DEFAULT_TAB_BAR_HEIGHT = isIphoneX() ? 83 : 49;

export const IS_IOS = Platform.OS === 'ios';

export const KEYBOARD_OPEN_TIME = IS_IOS ? 250 : 0;

export const CONTENT_VIEW_STYLE = {
  width: '100%',
} as const;
